import React from 'react';
import PropTypes from 'prop-types';

import {
  Image,
  ExtendedFlex,
  ExtendedBox,
  Link,
  Body,
} from '../../coreui';

import FadeIn from '../../components/FadeIn';

import dist1 from '../../assets/img_annual_dist.png';
import nav1 from '../../assets/img_nav.png';
import dist2 from '../../assets/mr2_img_annual_dist.png';
import nav2 from '../../assets/img_nav_mr2.png';
import dlIcon from '../../assets/icon_download.svg';

class Performance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      io,
    } = this.props;

    let dist = null;
    let nav = null;
    let distHref = '';
    const nonMR1 = true;

    switch (io.id) {
      case 274949:
        dist = dist2;
        nav = nav2;
        distHref = '/materials/mr2/distribution_history.pdf';
        break;

      default:
        dist = dist1;
        nav = nav1;
        distHref = '/materials/mr1/distribution_history.pdf';
        break;
    }

    return (
      <ExtendedBox>
        <ExtendedFlex
          flexDirection={['column', 'row']}
          justifyContent="center"
          align="center"
          maxWidth={1500}
          py={[25, 25, 50]}
          mx="5%"
          alignItems={['center', 'flex-start']}
        >
          <FadeIn>
            <ExtendedBox
              width={['90%', '90%', '48%', '35%', '48%']}
              mr={[0, 20]}
              textAlign="center"
              maxWidth="800px"
              minWidth={['auto', 'auto', '400px', '400px', '400px']}
            >
              <Image src={dist} width="100%" height="auto" mb={30} />
            </ExtendedBox>
            <ExtendedBox
              width={['90%', '90%', '48%', '35%', '48%']}
              textAlign="center"
              maxWidth="698px"
              minWidth={['auto', 'auto', '400px', '400px', '400px']}
              mt={[40, 0]}
            >
              <Image src={nav} width="100%" height="auto" mb={30} />
            </ExtendedBox>
          </FadeIn>
        </ExtendedFlex>
        <ExtendedFlex
          width="100%"
          justifyContent="center"
          mt={45}
          flexDirection={['column', 'row']}
          alignItems="center"
        >
          <FadeIn>
            <ExtendedBox
              width={[280, 280, 340, 340, 340]}
              bg="gray.0"
              mr={[0, 20]}
              mb={[25, 0]}
            >
              <Link
                type="L4"
                href={distHref}
                display="flex"
                flexDirection="row"
                alignItems="center"
                py={[10, 10, 20, 20, 20]}
                px={[15, 15, 25, 25, 25]}
                width="100%"
                target="_blank"
              >
                <Image
                  src={dlIcon}
                  height="25px"
                  alt="Download"
                  mr={20}
                  style={{
                    cursor: 'pointer',
                  }}
                />
                Distribution History
              </Link>
            </ExtendedBox>
          </FadeIn>
        </ExtendedFlex>
        {!nonMR1 && (
          <ExtendedFlex
            mt={35}
            width="100%"
            maxWidth="600px"
            flexDirection="row"
            mx="auto"
            pb="5%"
          >
            <FadeIn>
              <Body type="B2" textAlign="center">
                The annualized distribution rate is not a guarantee or
                projection of future distributions and may be modified at
                the REIT&apos;s discretion.
              </Body>
            </FadeIn>
          </ExtendedFlex>
        )}
      </ExtendedBox>
    );
  }
}

Performance.propTypes = {
  io: PropTypes.object,
};

export default Performance;
